import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/login.css";
import kakaoLogo from "../assets/kakao.png";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [userPw, setUserPw] = useState("");

  // 카카오 SDK 초기화
  useEffect(() => {
    const KAKAO_KEY = process.env.REACT_APP_KAKAO_KEY;
    if (!window.Kakao.isInitialized()) {
      window.Kakao.init(KAKAO_KEY);
      console.log("Kakao SDK Initialized:", window.Kakao.isInitialized());
    }

    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUserId(storedUser.userId);
    }
  }, []);

  // 일반 로그인 처리
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userId === "" || userPw === "") {
      alert("아이디와 비밀번호를 모두 입력해주세요.");
      return;
    }

    try {
      let users = [];
      if (process.env.NODE_ENV === "production") {
        // Production 환경: 모의 데이터를 사용 (외부 API 서버가 없으므로)
        users = [
          { userId: "test1", userPw: "1234", userName: "홍길동" },
          { userId: "test2", userPw: "1234", userName: "김길동" },
          { userId: "test3", userPw: "1234", userName: "최길동" },
        ];
      } else {
        // Development 환경: 로컬 json-server API 호출
        const response = await axios.get("http://localhost:3001/users");
        users = response.data;
      }

      const user = users.find(
        (storedUser) =>
          storedUser.userId === userId && storedUser.userPw === userPw
      );

      if (user) {
        alert("로그인 성공!");
        localStorage.setItem(
          "user",
          JSON.stringify({
            userId,
            userPw,
            userName: user.userName || "",
          })
        );
        navigate("/");
      } else {
        alert("아이디 또는 비밀번호가 잘못되었습니다.");
      }
    } catch (error) {
      console.error("로그인 오류", error);
      alert("로그인 중 오류가 발생했습니다.");
    }
  };

  // 카카오 로그인 처리
  const handleKakaoLogin = () => {
    window.Kakao.Auth.login({
      success: (authObj) => {
        window.Kakao.API.request({
          url: "/v2/user/me",
          success: async (res) => {
            const kakaoUserId = res.id;
            const kakaoUserName = res.kakao_account.profile.nickname;
            const kakaoUserPw = "kakao"; // 고정값

            try {
              if (process.env.NODE_ENV === "development") {
                // 개발 환경: 실제 json-server API 호출
                const response = await axios.get("http://localhost:3001/users");
                const users = response.data;
                const existingUser = users.find(
                  (user) => user.userId === kakaoUserId.toString()
                );
                if (!existingUser) {
                  await axios.post("http://localhost:3001/users", {
                    userId: kakaoUserId.toString(),
                    userPw: kakaoUserPw,
                    userName: kakaoUserName,
                  });
                }
              }
              // Production 환경 (또는 모의 데이터 방식): 바로 localStorage에 저장
              localStorage.setItem(
                "user",
                JSON.stringify({
                  userId: kakaoUserId.toString(),
                  userPw: kakaoUserPw,
                  userName: kakaoUserName,
                })
              );
              alert(`${kakaoUserName}님, 환영합니다!`);
              navigate("/");
            } catch (error) {
              console.error("카카오 로그인 처리 오류:", error);
              alert("카카오 로그인 중 오류가 발생했습니다.");
            }
          },
          fail: (error) => {
            console.error("사용자 정보 요청 실패:", error);
          },
        });
      },
      fail: (err) => {
        console.error("Kakao 로그인 실패:", err);
      },
    });
  };

  const handleUserIdChange = (e) => {
    setUserId(e.target.value);
  };

  const handleUserPwChange = (e) => {
    setUserPw(e.target.value);
  };

  return (
    <div className="login-container">
      <Header />
      <main className="login-main">
        <h2 className="login-title">로그인</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="login-input"
            placeholder="아이디"
            value={userId}
            onChange={handleUserIdChange}
          />
          <input
            type="password"
            className="login-input"
            placeholder="비밀번호"
            value={userPw}
            onChange={handleUserPwChange}
            autoComplete="current-password"
          />
          <button type="submit" className="login-button">
            로그인
          </button>
        </form>

        <div className="kakao-login">
          <button onClick={handleKakaoLogin} className="kakao-login-button">
            <img src={kakaoLogo} alt="kakao" className="kakao-logo" />
            카카오톡으로 로그인
          </button>
        </div>

        <p className="login-signup">
          계정이 없으신가요? <a href="/signup">회원가입</a>
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default Login;
